import axios from 'axios';
import { ApiResponse, Order } from '../types/requestModel';
import { requestIdEndpoint } from '../endpoint';
import { getEnvironmentEndpoint } from '../utils/getEnvironmentEndpoint';

export const fetchOrderIds = async (customerId: number): Promise<Order[]> => {
  const endpoint = getEnvironmentEndpoint(requestIdEndpoint);
  const response = await axios.post<ApiResponse>(
    endpoint,
    {
      event: 'getOrderIds',
      payload: {
        customerId,
      },
    },
    {
      headers: {
        'Content-Type': 'application/json',
        Authorization: 'Bearer retool_wk_321c2ee2678f41bfbf09975b1b9ad303',
      },
    },
  );

  return response.data.orders;
};
